export const clickedBrandIcon =  {
    eventCategory: "homepage_dweb",
    event: "clicked_brand_icon",
    eventAction: "Brand selected"
};
